import { z } from 'zod'

/**
 * Why an MCP connection ended. Stored on `McpConnection.revokedReason` (a
 * string column) and on `mcp.disconnected` activity. One list so the API that
 * writes the reason and the activity log that explains it cannot drift.
 */
export const CONNECTION_END_REASONS = [
  'user_disconnected',
  'staff_disconnected',
  'password_reset',
  'account_removed',
  'refresh_reuse',
  'code_reuse',
  'idle',
  'expired',
] as const

export const connectionEndReasonSchema = z.enum(CONNECTION_END_REASONS)

export type ConnectionEndReason = z.infer<typeof connectionEndReasonSchema>
